import { Stack } from '@mui/material';
import { ReactNode } from 'react';

type PageHeaderActionsProps = {
  /**
   * Action controls — typically `PIconButton`, `PButtonWithPopover`, or
   * `PButton` elements. The slot accepts any `ReactNode`; the design system
   * does not constrain the action shape. See ADR-007.
   */
  children: ReactNode;
};

export const PageHeaderActions = ({ children }: PageHeaderActionsProps) => {
  return (
    <Stack direction="row" gap={1} alignItems="center" justifyContent="flex-end" flexShrink={0}>
      {children}
    </Stack>
  );
};
